module.exports = {
    EuMemberState: 'EU member state'
};